import { render } from "./MToken.vue?vue&type=template&id=5acb0206&scoped=true&ts=true"
import script from "./MToken.vue?vue&type=script&lang=ts"
export * from "./MToken.vue?vue&type=script&lang=ts"

import "./MToken.vue?vue&type=style&index=0&id=5acb0206&lang=scss&scoped=true"
import "./MToken.vue?vue&type=style&index=1&id=5acb0206&lang=scss"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acb0206"]])

export default __exports__